import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, IRepair, IRepairsQueryMetadata, IRepairsQueryParams } from 'gen/ApiClient';
import React from 'react';

export const RepairsQueryContext = React.createContext<IQueryContext<IQueryResultWithMetadata<IRepair, IRepairsQueryMetadata>, IRepairsQueryParams>>(
	undefined as any
);
